'use client';

import {ArrowRight} from 'lucide-react';
import {transactionContextContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderDark, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function TransactionContextSection() {
  return (
    <section
      id={transactionContextContent.id}
      aria-labelledby="context-heading"
      className={`relative ${sectionPadding} bg-kobra-dark ${sectionBorderDark} overflow-hidden`}
    >
      <div aria-hidden="true" className="absolute inset-0">
        <img
          src="/image/hero2.png"
          alt=""
          width={1672}
          height={941}
          className="absolute inset-0 h-full w-full object-cover object-[50%_100%] lg:object-[50%_90%]"
        />
      </div>

      <div className="relative z-10">
        <SectionContainer>
          <FadeIn>
            <SectionHeader
              title={transactionContextContent.title}
              description={transactionContextContent.description}
              dark
            />
          </FadeIn>

          <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 mb-8">
            {[transactionContextContent.sent, transactionContextContent.received].map((block, index) => (
              <FadeIn key={block.title} delay={index * 0.1} className="h-full">
                <article className={`h-full bg-kobra-surface/95 border border-kobra-border-dark rounded-2xl p-6 lg:p-8 hover:border-kobra-accent/40 ${cardHoverClass}`}>
                  <h3 className="text-lg font-bold text-white mb-5">{block.title}</h3>
                  <ul className="space-y-3">
                    {block.items.map((item) => (
                      <li key={item} className="text-sm text-kobra-text-muted-light flex items-start gap-3">
                        <ArrowRight className="w-4 h-4 text-kobra-accent shrink-0 mt-0.5" aria-hidden="true" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </article>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.2}>
            <p className="text-center text-sm text-kobra-text-muted-light max-w-3xl mx-auto border border-kobra-border-dark bg-kobra-surface/95 rounded-xl px-5 py-4">
              {transactionContextContent.note}
            </p>
          </FadeIn>
        </SectionContainer>
      </div>
    </section>
  );
}
